<template>
    <section v-if="settingStore.isSettingFetched" class="custom-checkbox">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">
                            {{ localizationStore.translate('admin.setting.title.one') }}
                        </h4>
                    </div>
                    <div class="card-body">
                        <div class="demo-inline-spacing">
                            <div class="custom-control custom-checkbox">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="enable-trial-popup"
                                    v-model="settingStore.trial.enable_popup"
                                    true-value="1"
                                    false-value="0"
                                    @change="updateSetting()"
                                />
                                <label class="custom-control-label" for="enable-trial-popup">
                                    {{ localizationStore.translate('admin.setting.trial.checkbox.label.one') }}
                                </label>
                            </div>
                            <div class="custom-control custom-checkbox">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="enable-trial-banner"
                                    v-model="settingStore.trial.enable_banner"
                                    true-value="1"
                                    false-value="0"
                                    @change="updateSetting()"
                                />
                                <label class="custom-control-label" for="enable-trial-banner">
                                    {{ localizationStore.translate('admin.setting.trial.checkbox.label.two') }}
                                </label>
                            </div>
                            <div class="custom-control custom-checkbox">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="enable-dashboard-banner"
                                    v-model="settingStore.isDashboardBannerEnable"
                                    true-value="1"
                                    false-value="0"
                                    @change="updateSetting()"
                                />
                                <label class="custom-control-label" for="enable-dashboard-banner">
                                    {{ localizationStore.translate('admin.setting.dashboard.banner.one') }}
                                </label>
                            </div>
                        </div>
                        <h4 class="mb-0 mt-2">Dashboard Banner:</h4>
                        <div class="form-group">
                            <textarea
                                v-model="settingStore.dashboardBanner"
                                class="form-control mt-50"
                                rows="3"
                                placeholder="Dashboard Banner"
                            ></textarea>
                        </div>
                        <div class="form-group">
                            <button @click="updateSetting()" type="button" class="btn btn-primary">
                                Update
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { ref } from 'vue'
import { useLocalizationStore } from '../../stores/LocalizationStore.js'
import { useSettingStore } from '../../stores/SettingStore.js'

export default {
    components: {
    },
    setup() {
        return {
            localizationStore: useLocalizationStore(),
            settingStore: useSettingStore(),
        }
    },
    mounted() {
        useSettingStore().fetchSetting();
    },
    methods:{
        updateSetting() {
            const route = this.$router.resolve(
                {
                    name: 'admin-settings'
                }
            );
            axios.post(
                route.href,
                {
                    dashboard_banner: this.settingStore.dashboardBanner,
                    enable_dashboard_banner: this.settingStore.isDashboardBannerEnable,
                    ...this.settingStore.trial
                }
            )
            .then(function (response) {
                if(response.data.error == true) {
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                toastr.success(response.data.message, 'Success!');
            })
            .catch(function (error) {
                console.log(error);
            });
        }
    }
}
</script>